import React, { Fragment } from "react";
import GenericHeader from "../../common/Header";

class HeaderLayout extends React.Component {
  state = {};
  constructor() {
    super();
    this.headerLayout = [
      {
        label: {
          value: "Item",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "itemNumber",
          autoFocus: true,
          onBlur: "lookup",
          hotMod: false,
        },
        size: "17%"
      },
      {
        label: {
          value: "Description",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "description"
        },
        readOnly: true,
        size: "48.8%"
      },
      {
        label: {
          value: "Warehouse",
          size: "auto"
        },
        item: {
          node: "DCSelector",
          value: "",
          intemName: "wse",
          singleSelect: true,
          onChange: "lookup"
        },
        readOnly: true,
        size: "26.6%"
      },
      {
        label: {
          value: "Year",
          size: "auto"
        },
        item: {
          node: "input",
          type: "number",
          value: "",
          intemName: "year",
          hotMod: false,
          maxLength: 4
        },
        size: "7.5%"
      }
    ];
  }
  componentDidMount() {
    this.setState({ layout: this.headerLayout });
  }

  formatData = props => {
    if (props) {
      this.headerLayout.map((layout, key) => {
        if (layout.item.intemName === props[key].name) {
          layout.item.value =
            props[key].value === undefined ||
            props[key].value === "" ||
            props[key].value === false
              ? ""
              : props[key].value;
          layout.item.obj = props[key].obj;
          layout.item.span = props[key].span;
          layout.label.value = props[key].label;
        }
        return null;
      });
    }
    return null;
  };
  getHeaderInfo = info => {
    this.props.setHeaderInfo({ header: info });
  };
  renderHeader = () => {
    this.formatData(this.props.headerData);
    return (
      <GenericHeader
        jsonObj={this.state.layout}
        setHeaderInfo={this.getHeaderInfo}
        functions={{
          lookup: this.props.lookup,
          setErrorMessage: this.props.setErrorMessage,
          setSuccessMessage: this.props.setSuccessMessage
        }}
      />
    );
  };
  render() {
    return <Fragment>{this.renderHeader()}</Fragment>;
  }
}
export default HeaderLayout;
